import axios from "axios";

// Netplus "Bank Reconciliation" — mutations + downloads.
// GET reads live in appApi.js. Auth + x-project-id come from the global
// axios interceptor.

const API = `${process.env.REACT_APP_API_URL || "http://localhost:5001"}/api/netplus/bank-recon`;

export const createReconRun = ({
  partnerCode,
  periodType,
  fromDate,
  toDate,
  bankFile,
  ourFile,
  amountTolerance,
}) => {
  const fd = new FormData();
  fd.append("partnerCode", partnerCode);
  fd.append("periodType", periodType);
  fd.append("fromDate", fromDate);
  if (toDate) fd.append("toDate", toDate);
  fd.append("bankFile", bankFile);
  fd.append("ourFile", ourFile);
  if (amountTolerance != null && !Number.isNaN(amountTolerance)) {
    fd.append("amountTolerance", String(amountTolerance));
  }
  return axios.post(`${API}/runs`, fd, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export const downloadReconExcel = async (runId) => {
  const res = await axios.get(`${API}/runs/${runId}/export`, {
    responseType: "blob",
  });
  const disp = res.headers["content-disposition"] || "";
  const m = disp.match(/filename="?([^"]+)"?/);
  const url = window.URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = m ? m[1] : "bank-reconciliation.xlsx";
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
};

export const deleteReconRun = (runId, partnerCode) =>
  axios.delete(`${API}/runs/${runId}`, { params: { partnerCode } });
